import {
  base_colorContentBorderSecondary,
  base_colorSurfaceSecondary,
  cta_linkTextAlert,
} from 'ext-ui/style/colors'
import {
  cornerRadius,
  flyout_headerVSpacing,
  spacing,
} from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_sm } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${flyout_headerVSpacing};

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(2)};
  }

  .content {
    .receipt-requirement-checkbox {
      display: flex;
      flex-direction: column;
      gap: ${spacing(2)};
      padding: ${spacing(4)} ${spacing(5)};
      margin-top: ${flyout_headerVSpacing};
      border: 1px solid ${base_colorContentBorderSecondary};
      background-color: ${base_colorSurfaceSecondary};
      border-radius: ${cornerRadius};

      .checkbox-and-label {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: ${spacing(3)};
      }

      .checkbox-subcopy {
        margin-left: ${spacing(8)};
      }
    }
  }
`

export const syncErrorStyle = css`
  ${font_sm};
  font-family: ${font_family_weight_medium};
  color: ${cta_linkTextAlert};
`

export const attachmentsIconStyling = css`
  transform: scale(1.6);
  margin-bottom: ${spacing(3)};
`

export const uploadErrorStyle = css`
  padding-left: 0%;
`
